import { useEffect, useRef } from "react";

export const FIELD_LABEL = {
  nome: "Nome do cliente", apresentacao: "Quem envia", agencia: "Agência", pedido: "Pedido", lista: "Lista do que falta",
  aqui: "Frase antes do link", link: "Link da página", entrar: "Como entrar", acesso: "Como entrar (curto)", consultor: "Consultor",
  morada: "Morada", cumprimento: "Cumprimento", o_negocio: "Negócio", imovel: "Imóvel",
};
const CHIP = "inline whitespace-pre-wrap rounded-md bg-sky-100 text-sky-900 px-1 py-0.5 cursor-default select-all";

function chip(k, sample) {
  const el = document.createElement("span");
  el.contentEditable = "false";
  el.dataset.ph = k;
  el.className = CHIP;
  el.title = `Parte automática · ${FIELD_LABEL[k] || k}`;
  el.textContent = sample?.[k] || `[${FIELD_LABEL[k] || k}]`;
  return el;
}

function build(root, tpl, sample) {
  root.replaceChildren();
  tpl.split(/(\{\w+\})/).forEach((part) => {
    const m = part.match(/^\{(\w+)\}$/);
    if (m) root.appendChild(chip(m[1], sample));
    else if (part) root.appendChild(document.createTextNode(part));
  });
}

function serialize(node) {
  let out = "";
  node.childNodes.forEach((n, i) => {
    if (n.nodeType === 3) out += n.nodeValue;
    else if (n.dataset?.ph) out += `{${n.dataset.ph}}`;
    else if (n.nodeName === "BR") out += "\n";
    else out += (i > 0 && /^(DIV|P)$/.test(n.nodeName) ? "\n" : "") + serialize(n);
  });
  return out.replace(/\u200b/g, "");
}

// Mensagem editável tal como o cliente a vê; as partes automáticas são etiquetas que não se partem.
export function MessageEditor({ value, sample, fields, onChange, testid }) {
  const ref = useRef(null);
  const last = useRef(null);
  useEffect(() => {
    if (value !== last.current) { build(ref.current, value, sample); last.current = value; }
  }, [value, sample]);
  const emit = () => { last.current = serialize(ref.current); onChange(last.current); };
  const type = (text) => { document.execCommand("insertText", false, text); emit(); };
  const insert = (k) => {
    const sel = window.getSelection();
    if (!sel.rangeCount || !ref.current.contains(sel.anchorNode)) { ref.current.appendChild(chip(k, sample)); emit(); return; }
    const r = sel.getRangeAt(0);
    r.deleteContents();
    const el = chip(k, sample);
    r.insertNode(el);
    r.setStartAfter(el); r.collapse(true); sel.removeAllRanges(); sel.addRange(r);
    emit();
  };
  return (
    <div>
      <div className="rounded-xl bg-[#E7F3EC] p-4">
        <div ref={ref} contentEditable suppressContentEditableWarning role="textbox" aria-multiline="true" data-testid={testid}
          onInput={emit} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); type("\n"); } }}
          onPaste={(e) => { e.preventDefault(); type(e.clipboardData.getData("text/plain")); }}
          className="bg-white rounded-lg shadow-sm px-3.5 py-3 text-sm text-slate-800 whitespace-pre-wrap leading-relaxed max-w-[460px] min-h-[120px] outline-none focus:ring-2 focus:ring-sky-300 cursor-text" />
      </div>
      <div className="flex flex-wrap gap-1.5 mt-2" data-testid={`${testid}-fields`}>
        <span className="text-[11px] text-slate-500 py-0.5">Acrescentar:</span>
        {fields.map((k) => (
          <button type="button" key={k} onMouseDown={(e) => e.preventDefault()} onClick={() => insert(k)}
            className="text-[11px] bg-sky-50 text-sky-900 border border-sky-200 rounded-md px-1.5 py-0.5 hover:bg-sky-100 transition-colors" data-testid={`${testid}-add-${k}`}>
            {FIELD_LABEL[k] || k}
          </button>
        ))}
      </div>
    </div>
  );
}
